module.exports = __webpack_public_path__ + "img/xl_yn.5001728e.png";